import Vue from 'vue'

import vTablePanel from './tablePanel.vue'
import vSimpleTable from './simpleTable.vue'
import vOperatePanel from './operatePanel.vue'
import vOptions from './options.vue'
import vPopup from './popup1.vue'
import vTree from './tree.vue'
import vUploadFile from './uploadFile.vue'

const components = [
    vTablePanel,
    vSimpleTable,
    vOperatePanel,
    vOptions,
    vPopup,
    vTree,
    vUploadFile
]

const install = function(Vue) {
    components.forEach(component => {
        Vue.component(component.name, component)
    })
}

install(Vue)


// WEBPACK FOOTER //
// ./src/components/index.js